import React from 'react';
import {
  required,
  Edit,
  TextInput,
  SimpleForm,
  TranslatableInputs,
  ReferenceInput,
  SelectInput,
  BooleanInput
} from 'react-admin';

// own ui
import EditTitle from '../../ui/edit-title';
import CustomEditToolbar from '../../ui/custom-edit-toolbar';

const validateCategoryService = required('Selecione uma categoria de serviço!');
const validateName = [required('Digite o nome!')];

const SubCategoryServiceEdit = (props) => (
  <Edit {...props} title={ <EditTitle subtitle="Editar Sub Categoria de Serviço: " value="name" subvalue="pt_br" /> }>
    <SimpleForm redirect="/sub-category-service" toolbar={<CustomEditToolbar />} >
      <TextInput source="id" label="Id" disabled />
      <ReferenceInput label="Categoria de Serviço" source="category_service_id" fullWidth={true} reference="category-service" validate={validateCategoryService}>
        <SelectInput optionText="name.pt_br" optionValue="id" />
      </ReferenceInput>
      <TranslatableInputs locales={['pt_br', 'en_us']} defaultLocale="pt_br">
        <TextInput source="name" label="Nome" fullWidth={true} validate={validateName} />
      </TranslatableInputs>
      <br/>
      <BooleanInput source="active" label="Ativo" />
    </SimpleForm>
  </Edit>
);

export default SubCategoryServiceEdit;
